import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { preHeatRecipeValidationSchema } from '../../constants';
import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../../../store/store';
import { PreHeatRecipeForm } from '../../Components/PreHeatRecipeForm';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import { IPreHeatRecipeEditable } from '../../../../types/recipes-types';
import { RECIPE_PATHS } from '../../../Recipes/constants';

type ComponentProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const PreHeatRecipeEdit: React.FC<ComponentProps> = ({
  preHeatRecipe,
  getPreHeatRecipe,
  updatePreHeatRecipe,
  reset,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const onSubmitHandler = useCallback(
    async (data: IPreHeatRecipeEditable) => {
      await updatePreHeatRecipe({ id, body: data });
      navigate(RECIPE_PATHS.BASE);
    },
    [id, updatePreHeatRecipe, navigate],
  );

  useEffect(() => {
    getPreHeatRecipe(id);
  }, [id]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);

  if (!preHeatRecipe) {
    return (
      <div className="flex w-full justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  return (
    <PreHeatRecipeForm
      initialValues={preHeatRecipe}
      validationSchema={preHeatRecipeValidationSchema}
      submitButtonName="Update"
      formName="Edit Pre-Heat Recipe"
      onSubmit={onSubmitHandler}
      enableTemperatureUnitSwitcher
    />
  );
};

const mapState = (state: RootState) => ({
  preHeatRecipe: state.pre_heat_recipes.preHeatRecipe,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getPreHeatRecipe: dispatch.pre_heat_recipes.getPreHeatRecipe,
  updatePreHeatRecipe: dispatch.pre_heat_recipes.updatePreHeatRecipe,
  reset: dispatch.pre_heat_recipes.resetOne,
});

export default connect(mapState, mapDispatch)(PreHeatRecipeEdit);
